import React, { useEffect, useState } from 'react';
import { CheckIcon, MinusIcon, PlusIcon, ShoppingCartIcon } from 'lucide-react';
import { Footer } from '../components/layout/Footer';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { TopBar } from '../components/layout/TopBar';
import { WhitehallVisualizerEmbed } from '../components/product/WhitehallVisualizerEmbed';
const productImage = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=6153&user=4145&v=1&w=800&h=800&file=uploaded%2Fimages%2FNew%20Design%202021%2FWhitehall%202021%2F16298_deluxe%20capitol%20package%20black.jpg';
const details = [['Brand', 'Whitehall'], ['SKU', '16298'], ['Condition', 'New'], ['Price', '$581.70'], ['Mailbox dimensions', '9.625 W × 13 H × 20.75 L'], ['Post dimensions', '4 × 4 × 54'], ['Shipping weight', '60 lb'], ['Shipping box dimensions', '24 × 14.5 × 19.5; 54 × 15 × 5']] as const;
export function WhitehallProductTest() {
  const [personalization, setPersonalization] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [isAdded, setIsAdded] = useState(false);
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Whitehall Products Deluxe Mailbox Package Black | MidAtlantic Mailboxes';
    return () => {
      document.title = previousTitle;
    };
  }, []);
  const canAddToCart = personalization.trim().length > 0;
  function handleAddToCart() {
    if (!canAddToCart) {
      document.getElementById('personalization-fields')?.focus();
      return;
    }
    setIsAdded(true);
  }
  return <div className="min-h-screen w-full bg-white text-[#1e2b2b]" data-id="element-2192" data-mp="3pnodsedm2cct">
      <TopBar data-id="element-2193" data-mp="3kvwhroborefa" />
      <Header data-id="element-2194" data-mp="3kvd0m9tv0u2b" />
      <Navigation data-id="element-2195" data-mp="3kuv89oabizzo" />

      <main className="min-w-0 overflow-x-hidden" data-id="element-2196" data-mp="3kubriawemhn8">
        <div className="border-b border-[#dce2df] bg-[#f6f8f6]" data-id="element-2197" data-mp="2x62adma4yi2f">
          <nav className="mx-auto w-full max-w-7xl min-w-0 px-4 py-3 text-sm text-[#5c6b67] sm:px-6 lg:px-8" aria-label="Breadcrumb" data-id="element-2198" data-mp="2x47l5vru03sj">
            <ol className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-2199" data-mp="3hulcoacg4i7e">
              <li data-id="element-2200" data-mp="3lw6jpf2au29o">
                <a href="/Home.html" className="transition hover:text-[#315e49] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#466957]" data-id="element-2201" data-mp="3lvndgvm0h2bh">
                  Home
                </a>
              </li>
              <li className="text-[#a3ada8]" data-id="element-2202" data-mp="2yws873m6c07w">/</li>
              <li data-id="element-2203" data-mp="2yy3epb707m2p">Mailboxes</li>
              <li className="text-[#a3ada8]" data-id="element-2204" data-mp="32y41pk8655ld">/</li>
              <li data-id="element-2205" data-mp="32yvms1453kxe">Complete Mailbox &amp; Post System</li>
              <li className="text-[#a3ada8]" data-id="element-2206" data-mp="37xgne1nb06md">/</li>
              <li className="min-w-0 font-medium text-[#34443f]" data-id="element-2207" data-mp="37vm1ol47kah8">
                Whitehall Systems
              </li>
            </ol>
          </nav>
        </div>

        <section className="mx-auto w-full max-w-7xl min-w-0 px-4 py-8 sm:px-6 lg:px-8 lg:py-10" data-id="element-2208" data-mp="n7hkw7p12pr5">
          <div className="grid min-w-0 grid-cols-1 items-start gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(380px,0.9fr)] lg:gap-14" data-id="element-2209" data-mp="s5j8n5xefd8y">
            <div className="min-w-0" data-id="element-2210" data-mp="2cnk3rghet67l">
              <div className="relative w-full min-w-0 overflow-hidden border border-[#dde4df] bg-[#f7f8f6] p-5 sm:p-8" data-id="element-2211" data-mp="27p0ep77ireb0">
                <img src={productImage} alt="Black Whitehall Deluxe Mailbox Package with a decorative post and personalized side panels" className="aspect-square w-full max-w-full object-contain mix-blend-multiply" data-id="element-2212" data-mp="22xs447ugdmw9" />
                <span className="absolute left-5 top-5 bg-[#e8eee8] px-3 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-[#3f5549]" data-id="element-2213" data-mp="1oysht6uexk39">
                  USPS approved
                </span>
              </div>
              <p className="mt-3 max-w-full text-sm leading-6 text-[#60706b]" data-id="element-2214" data-mp="1f14lich5s4iz">
                Product shown: Black. Personalized side panels are made to
                order.
              </p>
            </div>

            <div className="w-full max-w-full min-w-0" data-id="element-2215" data-mp="39ffcaqhbd8re">
              <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5b7566]" data-id="element-2216" data-mp="3hf22ukcxdk3o">
                Whitehall
              </p>
              <h1 className="mt-3 w-full max-w-full min-w-0 break-words font-serif text-3xl leading-tight text-[#203630] sm:text-4xl" data-id="element-2217" data-mp="3meem6v4l891i">
                Whitehall Products Deluxe Mailbox Package Black
              </h1>
              <div className="mt-4 flex max-w-full flex-wrap gap-x-4 gap-y-2 text-sm text-[#687671]" data-id="element-2218" data-mp="3cenrotg11u1f">
                <span data-id="element-2219" data-mp="2ymzj304zlnp7">SKU: 16298</span>
                <span data-id="element-2220" data-mp="33fahtznzr3g6">Condition: New</span>
              </div>

              <p className="mt-6 text-3xl font-semibold tracking-tight text-[#1d342c]" data-id="element-2221" data-mp="33gtxbo1tpagw">
                $581.70
              </p>

              <div className="mt-5 flex flex-wrap gap-2" aria-label="Product highlights" data-id="element-2222" data-mp="2oojqstu848e4">
                {['Oversized mailbox', 'Personalized side panels', 'USPS approved', 'Allow 3 weeks for delivery'].map(highlight => <span key={highlight} className="border border-[#d5e0d8] bg-[#f5f8f5] px-3 py-1.5 text-xs font-semibold text-[#436051]" data-id="element-2223" data-mp="213j46zybdfk1">
                    {highlight}
                  </span>)}
              </div>

              <section className="mt-7 w-full max-w-full min-w-0 border border-[#cad8ce] bg-[#f4f8f4] p-5 sm:p-6" aria-labelledby="personalization-heading" data-id="element-2224" data-mp="253t7g4uq1rv7">
                <div className="flex min-w-0 flex-wrap items-start justify-between gap-3" data-id="element-2225" data-mp="2f291afl4vf8e">
                  <div className="min-w-0" data-id="element-2226" data-mp="2ssvs7lknk0tx">
                    <h2 id="personalization-heading" className="text-xl font-semibold text-[#233b32]" data-id="element-2227" data-mp="2osk6e5gjzugv">
                      Personalize Side Panels
                    </h2>
                    <p className="mt-1 text-sm leading-6 text-[#5c6d65]" data-id="element-2228" data-mp="2xubchbf0a3b9">
                      Enter the final lettering exactly as it should appear on
                      your mailbox side panels.
                    </p>
                  </div>
                  <span className="text-xs font-bold uppercase tracking-[0.1em] text-[#436051]" data-id="element-2229" data-mp="1zf315gp4jkcc">
                    Required
                  </span>
                </div>

                <div id="personalization-fields" tabIndex={-1} className="mt-5 w-full max-w-full min-w-0 focus:outline-none" data-id="element-2230" data-mp="298tmicpyfent">
                  <label htmlFor="personalize-side-panels" className="block text-sm font-semibold text-[#31473f]" data-id="element-2231" data-mp="2j3vd7czvoosi">
                    Personalize Side Panels
                  </label>
                  <textarea id="personalize-side-panels" value={personalization} onChange={event => {
                  setPersonalization(event.target.value);
                  setIsAdded(false);
                }} rows={3} required aria-required="true" aria-describedby="personalization-help" className="mt-2 block w-full max-w-full min-w-0 resize-y border border-[#aebdb4] bg-white px-3.5 py-3 text-base text-[#1f302a] outline-none transition focus:border-[#4f735e] focus:ring-2 focus:ring-[#c5d8ca]" data-id="element-2232" data-mp="st8v5l03cm6x" />
                  <p id="personalization-help" className="mt-1.5 text-xs leading-5 text-[#65736d]" data-id="element-2233" data-mp="148c689ny5jsr">
                    Line 1 holds up to five 4.5-inch numbers. Line 2 holds up to
                    sixteen 1.25-inch characters.
                  </p>
                </div>

                <div className="mt-6 w-full max-w-full min-w-0 border-t border-[#d4e0d6] pt-5" data-id="element-2234" data-mp="3k0j9eoj90c9r">
                  <h3 className="text-base font-semibold text-[#2e473d]" data-id="element-2235" data-mp="3fwtny7xveasy">
                    Preview your personalization
                  </h3>
                  <p className="mt-1 text-sm leading-6 text-[#5a6d63]" data-id="element-2236" data-mp="1izd2sz1u2gtj">
                    This visualizer is for previewing only; enter final
                    personalization in the required side-panel field before
                    adding to cart.
                  </p>
                  <div className="mt-4 flex w-full max-w-full min-w-0 items-center" data-id="element-2237" data-mp="1ew6w5qat6nmj">
                    <WhitehallVisualizerEmbed data-id="element-2238" data-mp="22mj3ayy8cgc2" />
                  </div>
                </div>
              </section>

              <div className="mt-6 flex w-full max-w-full min-w-0 flex-col gap-4 sm:flex-row sm:items-end" data-id="element-2239" data-mp="26m1nfsi88ndu">
                <div className="min-w-0" data-id="element-2240" data-mp="1stc0nluvjefo">
                  <label htmlFor="quantity" className="mb-2 block text-sm font-bold uppercase tracking-[0.1em] text-[#334842]" data-id="element-2241" data-mp="1xtzo5xjw9d55">
                    Quantity
                  </label>
                  <div className="flex h-12 w-36 items-center border border-[#aebdb4] bg-white" data-id="element-2242" data-mp="2qcddf8r5zqsm">
                    <button type="button" onClick={() => setQuantity(current => Math.max(1, current - 1))} className="grid h-full w-11 place-items-center text-[#3e574d] transition hover:bg-[#eff4ef] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#466957]" aria-label="Decrease quantity" data-id="element-2243" data-mp="2zo2sxv6ap73b">
                      <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-2244" data-mp="2cqho2z0s9p9j" />
                    </button>
                    <input id="quantity" type="number" min="1" value={quantity} onChange={event => setQuantity(Math.max(1, Number(event.target.value) || 1))} className="h-full w-14 border-x border-[#aebdb4] text-center font-semibold outline-none" aria-label="Quantity" data-id="element-2245" data-mp="2qpqrey3w4ow3" />
                    <button type="button" onClick={() => setQuantity(current => current + 1)} className="grid h-full w-11 place-items-center text-[#3e574d] transition hover:bg-[#eff4ef] focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#466957]" aria-label="Increase quantity" data-id="element-2246" data-mp="3jl9b97nfqbi2">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-2247" data-mp="30lveyj28gooe" />
                    </button>
                  </div>
                </div>

                <button type="button" onClick={handleAddToCart} className="inline-flex min-h-12 w-full max-w-full min-w-0 items-center justify-center gap-2 break-words bg-[#2e5a45] px-4 py-3 text-center text-sm font-bold uppercase tracking-[0.09em] text-white transition hover:bg-[#244a39] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#244a39] focus-visible:ring-offset-2 sm:h-12 sm:flex-1 sm:px-6 sm:py-0" data-id="element-2248" data-mp="2vp4wjp2yhgzt">
                  {isAdded ? <CheckIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-2249" data-mp="1g4contiyai9a" /> : <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-2250" data-mp="jfwluvqtyce8" />}
                  {isAdded ? 'Added to Cart' : 'Add to Cart'}
                </button>
              </div>

              {!canAddToCart && <p className="mt-3 max-w-full text-sm text-[#697770]" data-id="element-2251" data-mp="xbs36x5kzffi">
                  Complete the required Personalize Side Panels field to add
                  this package to your cart.
                </p>}
              {isAdded && <p className="mt-3 flex items-center gap-2 text-sm font-medium text-[#2d6249]" role="status" data-id="element-2252" data-mp="1j3uo9vjbd0ar">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-2253" data-mp="1t2sdl0okcxut" />
                  Your mailbox package has been added to cart.
                </p>}
            </div>
          </div>
        </section>

        <section className="w-full max-w-full min-w-0 border-y border-[#d8e0db] bg-[#f7f9f7]" data-id="element-2254" data-mp="10dlfg2t0uaa3">
          <div className="mx-auto w-full max-w-7xl min-w-0 space-y-12 px-4 py-10 sm:px-6 lg:px-8 lg:py-14" data-id="element-2255" data-mp="vftl724wmc2q">
            <section className="w-full max-w-4xl min-w-0" aria-labelledby="description-heading" data-id="element-2256" data-mp="1a4g57h5h7s0a">
              <h2 id="description-heading" className="font-serif text-3xl text-[#203630]" data-id="element-2257" data-mp="15c6dbvkswhvd">
                Description
              </h2>
              <div className="mt-5 space-y-4 leading-7 text-[#53645d]" data-id="element-2258" data-mp="coakx329lc4e">
                <p data-id="element-2259" data-mp="2obw0zet4kr5p">
                  Whitehall curbside mailbox package with an oversized Capital
                  street-side mailbox, deluxe post with ball finial, post
                  brackets, and decorative personalized side panels. The mailbox
                  and side panels are constructed of die-cast aluminum and
                  finished with a durable, weather-resistant powder coat.
                </p>
                <p data-id="element-2260" data-mp="3736mthjzudqq">
                  The oversized mailbox measures 9.625 inches wide by 13 inches
                  high by 20.75 inches long, about 20% larger than many premium
                  mailboxes. It can hold a larger amount of mail and packages,
                  and it is large enough for magazines to lay flat. The deluxe
                  post measures 4 inches by 4 inches by 54 inches.
                </p>
              </div>

              <h3 className="mt-7 text-lg font-semibold text-[#2d463b]" data-id="element-2261" data-mp="1qof1fol9m6qx">
                Included in this package
              </h3>
              <ul className="mt-3 grid gap-2 text-sm leading-6 text-[#56675f] sm:grid-cols-2" data-id="element-2262" data-mp="26wlaa5hnag53">
                {['Whitehall Capital street-side mailbox', 'Deluxe post with ball finial', 'Post brackets', 'Personalized side panels'].map(item => <li key={item} className="flex gap-2" data-id="element-2263" data-mp="1s4kiu3tjy0t8">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-[#52725f]" aria-hidden="true" data-id="element-2264" data-mp="2ptcpa2q5m93c" />
                    {item}
                  </li>)}
              </ul>
            </section>

            <section className="w-full max-w-full min-w-0" aria-labelledby="details-heading" data-id="element-2265" data-mp="2buwikbsakil7">
              <h2 id="details-heading" className="font-serif text-3xl text-[#203630]" data-id="element-2266" data-mp="14huir80rkgb9">
                Product Details
              </h2>
              <dl className="mt-5 w-full max-w-full min-w-0 divide-y divide-[#d4ddd7] border-y border-[#d4ddd7] bg-white" data-id="element-2267" data-mp="3c3m9u8qskfs8">
                {details.map(([term, description]) => <div key={term} className="grid gap-1 px-4 py-4 sm:grid-cols-[13rem_1fr] sm:gap-6 sm:px-6" data-id="element-2268" data-mp="3l2zjb1ex14cy">
                    <dt className="font-semibold text-[#31473f]" data-id="element-2269" data-mp="3pw2fziezotxd">{term}</dt>
                    <dd className="text-[#5a6b63]" data-id="element-2270" data-mp="3ut17dt79qmrv">{description}</dd>
                  </div>)}
              </dl>
            </section>

            <section className="w-full max-w-4xl min-w-0" aria-labelledby="delivery-heading" data-id="element-2271" data-mp="7o37vuybj31n">
              <h2 id="delivery-heading" className="font-serif text-3xl text-[#203630]" data-id="element-2272" data-mp="cmee7vpemvf4">
                Personalization &amp; Delivery
              </h2>
              <div className="mt-5 grid w-full max-w-full min-w-0 gap-6 md:grid-cols-2" data-id="element-2273" data-mp="2efktaa1725nx">
                <div className="border-l-2 border-[#5d806b] pl-5" data-id="element-2274" data-mp="3hqrl7665x2cp">
                  <h3 className="font-semibold text-[#2d463b]" data-id="element-2275" data-mp="3crez4nn47zb6">
                    Side panel requirements
                  </h3>
                  <p className="mt-2 text-sm leading-7 text-[#56675f]" data-id="element-2276" data-mp="3qrg0e47al8r6">
                    Line 1 holds up to five 4.5-inch numbers. Line 2 holds up to
                    sixteen 1.25-inch characters. Review your entries carefully
                    before adding the personalized package to cart.
                  </p>
                </div>
                <div className="border-l-2 border-[#5d806b] pl-5" data-id="element-2277" data-mp="3vnwwplonatfc">
                  <h3 className="font-semibold text-[#2d463b]" data-id="element-2278" data-mp="db8nj4kq2brx">
                    Delivery information
                  </h3>
                  <p className="mt-2 text-sm leading-7 text-[#56675f]" data-id="element-2279" data-mp="9cj00j5yzduk">
                    Product shown: Black. This mailbox package is USPS approved.
                    Please allow 3 weeks for delivery.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </section>
      </main>

      <Footer data-id="element-2280" data-mp="16vznh7qpkubc" />
    </div>;
}